import { Component, OnDestroy, OnInit, Signal } from '@angular/core';
import { Actions, ofActionSuccessful } from '@ngxs/store';

import { UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { CheckPersonRulesMatrixModel } from '@bayclubs/court-booking-employee-api';
import { LoadCourtsAction, SaveCourtBookingSuccessAction } from '../../+store/court-booking-save.actions';
import { CourtBookingSaveInputModel } from '../../models/court-booking-save-input.model';
import { CourtBookingSaveFormService } from '../../services/court-booking-save-form.service';
import { CourtBookingSaveFacade } from './../../+store/court-booking-save.facade';

@Component({
    selector: 'app-court-booking-save-modal',
    templateUrl: './court-booking-save-modal.component.html',
    styleUrls: ['./court-booking-save-modal.component.scss'],
    standalone: false
})
export class CourtBookingSaveModalComponent implements OnInit, OnDestroy {
    public courtBookingInput: CourtBookingSaveInputModel;

    isMainPlayerSelected: Signal<boolean> = this.courtBookingSaveFacade.isMainPlayerSelected;
    firstPlayerRules: Signal<CheckPersonRulesMatrixModel | null> = this.courtBookingSaveFacade.firstPlayerRulesMatrix;
    showFormSpinner: Signal<boolean> = this.courtBookingSaveFacade.showFormSpinner;
    isFormValid: Signal<boolean> = this.courtBookingSaveFacade.isFormValid;
    formLoading: Signal<boolean> = this.courtBookingSaveFacade.formLoading;

    subscription: Subscription = new Subscription();

    formLoaded: boolean = false;
    private internalForm: UntypedFormGroup;
    set form(value: UntypedFormGroup) {
        this.internalForm = value;
        this.subscription.add(
            this.internalForm.valueChanges.pipe(debounceTime(500)).subscribe(formValue => {
                if (
                    formValue.date !== null &&
                    formValue.courtId != null &&
                    formValue.firstPlayer !== null
                ) {
                    this.courtBookingSaveFacade.checkPlayersMatrix();
                }
            })
        );
    }

    get form(): UntypedFormGroup {
        return this.internalForm;
    }

    constructor(
        public bsModalRef: BsModalRef,
        private formService: CourtBookingSaveFormService,
        private courtBookingSaveFacade: CourtBookingSaveFacade,
        private actions$: Actions
    ) { }

    ngOnInit(): void {
        document.documentElement.style.overflowY = 'hidden';

        this.courtBookingSaveFacade.loadCourts(this.courtBookingInput.date);
        this.subscription.add(
            this.actions$.pipe(ofActionSuccessful(LoadCourtsAction)).subscribe(value => {
                if (!this.formLoaded) {
                    this.form = this.formService.initForm(this.courtBookingInput);
                    this.formLoaded = true;
                }
            })
        );

        this.subscription.add(
            this.actions$.pipe(ofActionSuccessful(SaveCourtBookingSuccessAction)).subscribe(value => {
                this.bsModalRef.hide();
            })
        );
    }

    ngOnDestroy(): void {
        document.documentElement.style.overflowY = '';
        this.subscription.unsubscribe();
        this.courtBookingSaveFacade.clearSaveForm();
    }

    save(): void {
        this.courtBookingSaveFacade.saveCourtBooking();
    }
}
